// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuizBannerTop_wrapper__QY8nq"};